import { render, staticRenderFns } from "./startExam.vue?vue&type=template&id=0d2135ad&scoped=true"
import script from "./startExam.vue?vue&type=script&lang=js"
export * from "./startExam.vue?vue&type=script&lang=js"
import style0 from "./startExam.vue?vue&type=style&index=0&id=0d2135ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2135ad",
  null
  
)

export default component.exports